import { createAction } from 'redux-actions'

import * as constants from './constants'

export const fetchOnboardingStatus = createAction(constants.FETCH_ONBOARDING_STATUS)
export const fetchOnboardingStatusSuccess = createAction(constants.FETCH_ONBOARDING_STATUS_SUCCESS)
export const fetchOnboardingStatusFailed = createAction(constants.FETCH_ONBOARDING_STATUS_FAILED)

export const patchOnboardingStatus = createAction(constants.PATCH_ONBOARDING_STATUS)
export const patchOnboardingStatusSuccess = createAction(constants.PATCH_ONBOARDING_STATUS_SUCCESS)
export const patchOnboardingStatusFailed = createAction(constants.PATCH_ONBOARDING_STATUS_FAILED)


// WEBPACK FOOTER //
// ./src/modules/state/actions.js